import React, { useState } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { useToggle, useAutoFocus } from 'hooks';
import { ButtonGroup, Button } from 'ui';
import request from 'utils/request_ajax';
import LinkButton from 'components/shared/LinkButton';
import Modal from 'components/shared/modal';

const DiscardButton = ({ discardPath, redirectPath }) => {
  const [modalVisible, toggleModalVisible] = useToggle();
  const [loading, toggleLoading] = useToggle();
  const [errorMessage, setErrorMessage] = useState();
  const autoFocus = useAutoFocus();

  async function handleDiscard() {
    try {
      toggleLoading();
      await request.post(discardPath);
      window.location = redirectPath;
    } catch (error) {
      toggleLoading();
      setErrorMessage(
        get(error, 'responseJSON.message', t('common.server_error')),
      );
    }
  }

  return (
    <>
      <LinkButton onClick={toggleModalVisible} className="mr-32">
        {t('drafts.discarding.discard_draft')}
      </LinkButton>
      <Modal
        show={modalVisible}
        dismissCallback={loading ? () => {} : toggleModalVisible}
        title={t('drafts.discarding.discard_draft')}
      >
        <div className="mb-24">
          {errorMessage && (
            <div className="ErrorContainer ErrorContainer--brandRed">
              {errorMessage}
            </div>
          )}
          <p
            dangerouslySetInnerHTML={{
              __html: t('drafts.discarding.confirmation_message_html'),
            }}
          />
          {t('common.note_with_colon')}{' '}
          {t('drafts.discarding.lesson_will_revert')}
        </div>
        <ButtonGroup alignEnd>
          <Button
            ref={autoFocus}
            onClick={toggleModalVisible}
            primary
            disabled={loading}
          >
            {t('common.cancel')}
          </Button>
          <Button onClick={handleDiscard} loading={loading}>
            {t('drafts.discarding.discard')}
          </Button>
        </ButtonGroup>
      </Modal>
    </>
  );
};

const mapStateToProps = ({ editor }) => ({
  discardPath: editor.discard_path,
  redirectPath: editor.lesson_overview_path,
});

export default connect(mapStateToProps)(DiscardButton);
